export const DKIM_PROVIDER_GODADDY_ID = 1;
export const DKIM_PROVIDER_BLUEHOST_ID = 2;
export const DKIM_PROVIDER_HOSTGATOR_ID = 3;
export const DKIM_PROVIDER_DREAMHOST_ID = 4;
export const DKIM_PROVIDER_LIQUIDWEB_ID = 5;
export const DKIM_PROVIDER_INMOTION_ID = 6;
export const DKIM_PROVIDER_OTHER_ID = 7;
